// Central contact configuration (placeholder — owner to replace later)
export const CONTACT = {
  phoneDisplay: "0535 364 12 13",
  phoneHref: "tel:+905353641213",
  whatsappNumber: "905353641213",
  whatsappHref: "https://wa.me/905353641213",
  instagramHandle: "@eksimayagurmesi",
  instagramHref: "https://www.instagram.com/eksimayagurmesi/",
  locationLine1: "Ataşehir",
  locationLine2: "İstanbul, Türkiye",
  emailDisplay: "info@eksimayagurmesi.com",
};

export const SHOPIER_URL =
  "https://www.shopier.com/ShowProductNew/storefront.php?shop=eksimayagurmesi&sid=RW5EbzZIajFmRGFoSUlrdTBfLTFfIF8g";

export function whatsappWithText(text) {
  const msg = encodeURIComponent(text);
  return `https://wa.me/${CONTACT.whatsappNumber}?text=${msg}`;
}

export const WHATSAPP_TRAINING_HREF = whatsappWithText(
  "Merhaba, Ekşi Maya Gurmesi web sitesinden ulaşıyorum. Eğitimler hakkında bilgi almak istiyorum."
);
